export default __webpack_public_path__ + "static/media/artwork-card-2.d1822dae.png";